import { Map, OrderedMap } from 'immutable'
const emptyFilters = OrderedMap()

export default {
  queryFilter: Map({ filters: emptyFilters, fields: [] }),
  userProfile: { isAuthenticated: false, token: '', user: {} },
  appStatus: { loading: null },
}
